import { WorkloadOptimizationState } from '@cast/types';

import {
  OptimizationType,
  PreparedWorkload,
} from 'features/workload-optimization';
import { PartialWorkloadUpdateRequest } from 'hooks/mutations/workload-optimization/useUpdateWorkloadV2Mutation';

import { OPTIMIZATION_TYPE_TO_SEPARATE_OPTIONS_MAP } from '../../../../_constants';
import { HpaV2Status } from '../../../../_hooks/useHpaV2Status';

type BuildWorkloadOptimizationUpdateRequestsParams = {
  workloads: PreparedWorkload[];
  selectedIds: string[];
  optimizationType: OptimizationType;
  hpaV2Status: HpaV2Status;
};

export const buildWorkloadOptimizationUpdateRequests = ({
  workloads,
  selectedIds,
  optimizationType,
  hpaV2Status,
}: BuildWorkloadOptimizationUpdateRequestsParams): PartialWorkloadUpdateRequest[] => {
  const { hpaEnabled, vpaEnabled } =
    OPTIMIZATION_TYPE_TO_SEPARATE_OPTIONS_MAP[optimizationType];

  return selectedIds
    .map((selectedId) =>
      workloads.find(
        ({
          id,
          workloadConfigV2: {
            vpaConfig: { managementOption: vpaManagementOption },
            hpaConfig: { managementOption: hpaManagementOption },
          },
        }) =>
          id === selectedId &&
          // If VPA on is clicked and workload is not managed
          ((vpaEnabled &&
            vpaManagementOption !== WorkloadOptimizationState.MANAGED) ||
            // If VPA off is clicked and workload is managed
            (!vpaEnabled &&
              vpaManagementOption !== WorkloadOptimizationState.READ_ONLY) ||
            // If HPA on is clicked and workload is not managed
            (hpaEnabled &&
              hpaManagementOption !== WorkloadOptimizationState.MANAGED) ||
            // If HPA off is clicked and workload is managed
            (!hpaEnabled &&
              hpaManagementOption !== WorkloadOptimizationState.READ_ONLY))
      )
    )
    .filter((workload): workload is PreparedWorkload => !!workload)
    .map((workload) => ({
      clusterId: workload.clusterId,
      workloadId: workload.id,
      workload: {
        workloadConfig: {
          vpaConfig: {
            managementOption: vpaEnabled
              ? WorkloadOptimizationState.MANAGED
              : WorkloadOptimizationState.READ_ONLY,
          },
          ...(hpaV2Status === 'available'
            ? {
                hpaConfig: {
                  managementOption: hpaEnabled
                    ? WorkloadOptimizationState.MANAGED
                    : WorkloadOptimizationState.READ_ONLY,
                },
              }
            : {}),
        },
      },
    }));
};
